export interface ISearchBarSettings {
  columns: eSearchBarColumns[];
}

export enum eSearchBarColumns {
  FileNumber = 'File Number',
  Buyer = 'Buyer',
  Address = 'Address',
  InternalStatus = "Status",
  ClosingDate = 'Closing Date',
  FeesLastEdited = 'Fees Updated At',
  LastVisit = 'Last Visit',
}
